"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.76 7.01a2.347 2.347 0 0 1-2.13 3.34H2.35C1.05 10.35 0 9.3 0 8s1.05-2.35 2.35-2.35h3.61v1H2.35C1.6 6.65 1 7.26 1 8c0 .74.61 1.35 1.35 1.35h5.28a1.35 1.35 0 0 0 1.23-1.91l.91-.42-.01-.01Zm3.89-1.37H8.38c-1.3 0-2.35 1.05-2.35 2.35 0 .34.07.67.21.98l.91-.42c-.08-.18-.12-.37-.12-.57 0-.75.61-1.35 1.35-1.35h5.27c.75 0 1.35.61 1.35 1.35 0 .74-.61 1.35-1.35 1.35h-3.61v1h3.61c1.3 0 2.35-1.05 2.35-2.35s-1.05-2.35-2.35-2.35v.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.505 10.582a3.388 3.388 0 0 1-3.075 4.8H3.39A3.388 3.388 0 0 1 .007 12 3.393 3.393 0 0 1 3.39 8.617h5.512v1.125H3.39A2.26 2.26 0 0 0 1.132 12a2.26 2.26 0 0 0 2.258 2.257h8.04A2.26 2.26 0 0 0 13.687 12c0-.33-.067-.653-.21-.945l1.02-.473h.008Zm6.112-1.972h-8.04a3.388 3.388 0 0 0-3.075 4.8l1.02-.473c-.135-.3-.21-.615-.21-.945a2.26 2.26 0 0 1 2.258-2.257h8.04a2.26 2.26 0 0 1 2.257 2.257 2.26 2.26 0 0 1-2.257 2.258h-5.513v1.125h5.513a3.388 3.388 0 0 0 3.382-3.383A3.393 3.393 0 0 0 20.61 8.61h.007Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.34 14.11a4.517 4.517 0 0 1-4.1 6.4H4.52C2.03 20.51.01 18.48.01 16s2.03-4.51 4.51-4.51h7.35v1.5H4.52c-1.66 0-3.01 1.35-3.01 3.01 0 1.66 1.35 3.01 3.01 3.01h10.72c1.66 0 3.01-1.35 3.01-3.01 0-.44-.09-.87-.28-1.26l1.36-.63h.01Zm8.15-2.63H16.77a4.517 4.517 0 0 0-4.1 6.4l1.36-.63c-.18-.4-.28-.82-.28-1.26 0-1.66 1.35-3.01 3.01-3.01h10.72c1.66 0 3.01 1.35 3.01 3.01 0 1.66-1.35 3.01-3.01 3.01h-7.35v1.5h7.35c2.49 0 4.51-2.03 4.51-4.51s-2.03-4.51-4.51-4.51h.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.867 21.225c.405.87.608 1.808.608 2.775 0 3.66-2.978 6.63-6.63 6.63H6.63A6.637 6.637 0 0 1 0 24c0-3.652 2.978-6.63 6.63-6.63h11.115v1.875H6.63A4.756 4.756 0 0 0 1.875 24a4.756 4.756 0 0 0 4.755 4.755h16.215a4.756 4.756 0 0 0 4.32-6.742l1.703-.788ZM41.37 17.37H25.155a6.637 6.637 0 0 0-6.023 9.405l1.703-.787a4.756 4.756 0 0 1 4.32-6.742H41.37A4.756 4.756 0 0 1 46.125 24a4.756 4.756 0 0 1-4.755 4.755H30.255v1.875H41.37c3.66 0 6.63-2.977 6.63-6.63 0-3.652-2.977-6.63-6.63-6.63Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.49 28.3c.54 1.16.81 2.41.81 3.7 0 4.88-3.97 8.84-8.84 8.84H8.84C3.96 40.84 0 36.87 0 32c0-4.87 3.97-8.84 8.84-8.84h14.82v2.5H8.84c-3.5 0-6.34 2.84-6.34 6.34s2.84 6.34 6.34 6.34h21.62a6.342 6.342 0 0 0 5.76-8.99l2.27-1.05Zm16.67-5.14H33.54c-4.88 0-8.84 3.97-8.84 8.84 0 1.29.27 2.54.81 3.7l2.27-1.05a6.342 6.342 0 0 1 5.76-8.99h21.62c3.5 0 6.34 2.84 6.34 6.34s-2.84 6.34-6.34 6.34H40.34v2.5h14.82c4.88 0 8.84-3.97 8.84-8.84 0-4.87-3.97-8.84-8.84-8.84Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconLink = function IconLink(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Link' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Link"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconLink.sizes = [16, 24, 32, 48, 64];
IconLink.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconLink;
exports.default = _default;